import { Space, Button, Tooltip, Typography } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

const buildColumns = ({ onEdit, onDelete, sortBy, sortOrder, page = 1, limit = 10 }) => {
  const sortDirections = ["ascend", "descend"];

  const sorterProps = (field) => ({
    sorter: true,
    sortDirections,
    sortOrder:
      sortBy === field ? (sortOrder === "asc" ? "ascend" : "descend") : null,
  });

  return [
    {
      title: "Sr. No",
      key: "sno",
      width: 80,
      align: "center",
      render: (_, __, index) => (
        <Typography.Text type="secondary" style={{ fontSize: 12 }}>
          {(page - 1) * limit + index + 1}
        </Typography.Text>
      ),
    },
    {
      title: "Tag",
      dataIndex: "tag",
      key: "tag",
      ellipsis: true,
      ...sorterProps("tag"),
      render: (val) => <span>{val}</span>,
    },
    {
      title: "Updated At",
      dataIndex: "updatedAt",
      key: "updated_at",
      width: 180,
      ...sorterProps("updated_at"),
      render: (val) =>
        val ? new Date(val).toLocaleString() : "—",
    },
    {
      title: "Actions",
      key: "actions",
      width: 120,
      fixed: "right",
      align: "center",
      render: (_, record) => (
        <Space>
          <Tooltip title="Edit">
            <Button
              size="small"
              icon={<EditOutlined />}
              onClick={() => onEdit?.(record)}
            />
          </Tooltip>
          <Tooltip title="Delete">
            <Button
              size="small"
              danger
              icon={<DeleteOutlined />}
              onClick={() => onDelete?.(record)}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];
};

export default buildColumns;
